import { keyframes } from 'styled-components'

export const BackdropFadeIn = keyframes`
    0% {
        background:rgba(0,0,0,.0);
    }

    100% {
        background:rgba(0,0,0,.7);
    }
`

export const BackdropFadeOut = keyframes`
    0% {
        background:rgba(0,0,0,.7);
    }

    100% {
        background:rgba(0,0,0,.0);
    }
`

export const ModalScrollDown = (endHeight) => keyframes`
    0% {
        height: 0vh;
    }

    100% {
        height: ${endHeight}vh;
    }
`

export const ModalReveal = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`

export const ModalSlideUp = keyframes`
    0% {
        top: 80%;
    }

    100% {
        top: 50%;
    }
`
